<!-- @format -->

<ng-container *ngFor="let item of detailsData">
	<section
		class="wysiwyg-details"
		[id]="
			item.headline || item.cta || 'wysiwygdetails' | dcsgStripSpecialChars: '\ |\'|\′|\&|\-'
		">
		<h3
			*ngIf="item.headline"
			class="hmf-pt-s text-center">
			{{ item.headline }}
		</h3>
		<home-wysiwyg
			*ngIf="[item.wysiwyg]"
			[data]="[item.wysiwyg]"
			[addlData]="addlData">
		</home-wysiwyg>
		<div
			*ngIf="item.cta"
			class="text ctas d-flex flex-column justify-content-center flex-md-row flex-md-wrap hmf-mb-m">
			<div
				*ngFor="let cta of item.cta; let j = index"
				class="text-center d-flex justify-content-center flex-wrap hmf-px-xxs hmf-my-xxs">
				<a
					homefield-button
					*ngIf="cta.link && cta.linkTitle"
					height="base"
					variant="secondary"
					[href]="cta.link"
					[attr.altText]="cta.linkTitle"
					[dataEm]="createTag(i + 1, j + 1, cta.linkTitle, item.headline)"
					[attr.target]="targetService(cta.link)"
					[attr.aria-label]="item.headline">
					{{ cta.linkTitle }}
				</a>
			</div>
		</div>
	</section>
</ng-container>
